export default {
  root: {
    borderRadius: 20,
  },
};
